<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 17:27:53
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-09-17 11:28:08
 * @name: 折扣审批流
 * @Description: 折扣审批流
 * @FilePath: \preSaleNafterSaleBackstage\src\views\approvalManage\discountApprovalManage.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    
  </div>
</template>
<script>

export default {
  name: "discountApprovalManage",
  components: {
    
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  },
};
</script>
<style lang="scss" scoped>

</style>